import { useSheetSurface } from "@ui/components/SheetSurface";
import { type ReactNode, useEffect } from "react";
import { surfaceFooter, surfaceFooterGradient } from "./sheet-chrome.styles";

export interface SurfaceFooterProps {
  /** Action buttons or links rendered at the bottom of the dialog */
  children: ReactNode;
  className?: string;
}

/** Bottom action bar with scroll-aware border and gradient fade. */
export function SurfaceFooter({ children, className }: SurfaceFooterProps) {
  const { isAtBottom, setHasFooter } = useSheetSurface();
  const hasOverflow = !isAtBottom;

  // Tell Dialog.Body a footer is present so it drops its own bottom padding.
  useEffect(() => {
    setHasFooter(true);
    return () => setHasFooter(false);
  }, [setHasFooter]);

  return (
    <div
      className={surfaceFooter({
        className: [className, hasOverflow ? "border-neutral-50 border-t" : "border-transparent border-t"],
      })}
    >
      <div aria-hidden className={surfaceFooterGradient({ visible: hasOverflow })} />
      {children}
    </div>
  );
}
